import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true })
export default class Tenants extends VuexModule {
  _tenants: Tenant[] = [];
  _selectedTenant?: Tenant = undefined;

  get tenants(): Tenant[] {
    return this._tenants;
  }

  get selectedTenant(): Tenant | undefined {
    return this._selectedTenant;
  }

  @Mutation
  SET_TENANT_LIST(tenants: Tenant[]) {
    this._tenants = tenants;
  }

  @Mutation
  SET_SELECTED_TENANT(tenant: Tenant) {
    this._selectedTenant = tenant;
  }

  @Mutation
  ADD_TENANT(tenant: Tenant) {
    this._tenants.push(tenant);
  }

  @Mutation
  REMOVE_TENANT(tenantId: string) {
    const idx = this._tenants.findIndex(el => el._id === tenantId);
    this._tenants.splice(idx, 1);
  }

  @Action
  async FETCH_TENANT_LIST(kuzzle: any) {
    const tenants: Tenant[] = [];

    try {
      const response = await kuzzle.query({
        controller: 'multi-tenancy/tenant',
        action: 'list'
      });

      for (const tenant of response.result.tenants) {
        tenants.push({
          _id: tenant._id,
          group: tenant._source.group,
          index: tenant._source.index,
          name: tenant._source.name
        });
      }

      this.context.commit('SET_SELECTED_TENANT', tenants[0]);
    } catch (error) {
      throw error;
    }

    this.context.commit('SET_TENANT_LIST', tenants);
  }

  @Action
  async FETCH_USER_TENANTS(kuzzle: any) {
    const tenants: Tenant[] = [];

    try {
      const response = await kuzzle.auth.getCurrentUser();

      for (const tenant of response.content.tenants) {
        tenants.push({
          _id: tenant.index,
          group: tenant.group,
          index: tenant.index,
          name: tenant.name
        });
      }

      this.context.commit('SET_SELECTED_TENANT', tenants[0]);
    } catch (error) {
      throw error;
    }

    this.context.commit('SET_TENANT_LIST', tenants);
  }
}

interface Tenant {
  _id: string;
  group: string;
  index: string;
  name: string;
}
